import React from 'react';

interface SkeletonCardProps {
  variant?: 'product' | 'article';
}

export const SkeletonCard: React.FC<SkeletonCardProps> = React.memo(
  ({ variant = 'product' }) => {
    if (variant === 'article') {
      return (
        <div className="bg-white rounded-lg overflow-hidden shadow-sm animate-pulse">
          <div className="flex gap-3 p-3">
            <div className="w-20 h-20 bg-gray-200 rounded-lg flex-shrink-0 skeleton-shimmer" />
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-3/4 skeleton-shimmer" />
              <div className="h-3 bg-gray-200 rounded w-full skeleton-shimmer" />
              <div className="h-3 bg-gray-200 rounded w-2/3 skeleton-shimmer" />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="bg-white rounded-lg overflow-hidden shadow-sm animate-pulse">
        {/* Image placeholder */}
        <div className="h-44 bg-gray-200 skeleton-shimmer" />

        {/* Content placeholder */}
        <div className="p-3 space-y-2">
          {/* Title */}
          <div className="h-4 bg-gray-200 rounded w-4/5 skeleton-shimmer" />
          <div className="h-4 bg-gray-200 rounded w-3/5 skeleton-shimmer" />

          {/* Producer/Region */}
          <div className="h-3 bg-gray-200 rounded w-1/2 skeleton-shimmer" />

          {/* Price */}
          <div className="flex items-center gap-2 pt-1">
            <div className="h-5 bg-gray-200 rounded w-16 skeleton-shimmer" />
            <div className="h-4 bg-gray-200 rounded w-12 skeleton-shimmer" />
          </div>
        </div>
      </div>
    );
  }
);

SkeletonCard.displayName = 'SkeletonCard';

interface SkeletonGridProps {
  count?: number;
  variant?: 'product' | 'article';
}

export const SkeletonGrid: React.FC<SkeletonGridProps> = React.memo(
  ({ count = 6, variant = 'product' }) => {
    return (
      <div
        className={
          variant === 'product'
            ? 'grid grid-cols-2 md:grid-cols-3 gap-3'
            : 'flex flex-col gap-2'
        }
      >
        {Array.from({ length: count }).map((_, i) => (
          <SkeletonCard key={i} variant={variant} />
        ))}
      </div>
    );
  }
);

SkeletonGrid.displayName = 'SkeletonGrid';
